module.exports = __webpack_public_path__ + "static/media/dvslogo_web_new_cropped.0fcfaed6.png";